import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Pagination from './../shared/pagination'
import vSelect from 'vue-select'
// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
	name: 'user',
	components: {
		Paginate,
		Pagination,
		VueElementLoading,
		vSelect
	},
	data: function () {
		return {
			totalRows: 0,
			checkrole: '',
			currentPage: 1,
			totalPage: 0,
			pageLimit: 10,
			modalShow: false,
			updateusermodal: false,
			editusermodal: false,
			addusermodal: false,
			useraction: '',
			listUserData: [],
			listRoleData: [],
			listClientData: [],
			listWarehouseData: [],
			props: [],
			// pageno: 0,
			// totalPage: 0,
			username: '',
			userid: '',
			rolename: '',
			isLoading: false,
			resultCount: '',
			warehouse: '',
			model: {
				name: '',
				username: '',
				useremail: '',
				userpassword: '',
				userconfirmpassword: '',
				client: '',
				warehouse: '',
				roleid: '',
			},
			adduser: {
				fullname: '',
				email: '',
				password: '',
				confirmpassword: '',
				roleid: '',
				clientid: '',
				warehouseid: '',
				usertype: ''
			},
			checked_roleid: [],
			status: '',
			changestatus: '',
			count: 0,
			email: '',
			localuserid: 0,
			showwarehouse: false,
			showclient: false,
			addusermodal: false,
			permissions: [
				{
					label: "b2bPieceLevelPicking",
					key: this.$t('userProperties.b2bPickScan'),
					value: false
				},
				{
					label: "b2bPieceLevelPacking",
					key: this.$t('userProperties.b2bPackScan'),
					value: false
				}],
			showfeaturepermission: false,
			userPersonname: "",
			listUserDatafilter: [],
			selecteduser: "",
			orderidlistArr: [],
			userrole: '',
			userproperty: '',
			updatedPermission: [],
			showSelectWarehouse: false,
			clonedArray: []
		}
	},
	created: function () {

	},
	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.localuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.pageno = 0

		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				// this.getWarehouseList();
				this.getUserData()
				break;

			case 'warehouse_user':
				this.warehouse = userdetail.warehouseid;
				this.showSelectWarehouse = false;
				this.getUserData()
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		closePopup() {
			this.showfeaturepermission = false
		},
		toggleAccordion(index) {
			this.permissionGroups[index].isActive = !this.permissionGroups[index].isActive;
		},
		closeAddUserModal() {
			this.addusermodal = false,
				this.$validator.reset();
			this.errors.clear();
		},
		closeStatusUserModal() {
			this.modalShow = false
		},

		useremailcheck() {
			this.finaluserEmail = [];

			if (this.selecteduser) {
				this.selecteduser = this.selecteduser.replace(/\n/g, '');
				this.selecteduser = this.selecteduser.replace(/,+/, ',');
				this.selecteduser = this.selecteduser.replace(/,$/, '');
			}
			let userCounts = this.selecteduser.split(',').length;
			if (userCounts > 50) {
				this.$alertify.error(this.$t('userProperties.only50Users'));
				return false
			}
			else {
				this.MultiorderArrFlag = false;
			}
		},

		getUserDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.getUserData();
		},
		getUserData() {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true;

			let params = {
				offset: (this.currentPage - 1) * 10,
				limit: 10,
			};

			if (this.selecteduser && this.selecteduser.length > 0) {
				let userCounts = this.selecteduser.split(',').length;

				if (userCounts > 50) {
					this.$alertify.error(this.$t('userProperties.only50Users'))
					this.isLoading = false
					return false
				}
				params.emails = this.selecteduser;
			}
			if (localStorage.getItem("selectedWarehouse")) {
				params.warehouseid = localStorage.getItem("selectedWarehouse");
			}

			if (this.userrole) {
				params.permissiontypes = this.userrole;
			}

			if (this.userproperty) {
				params.property = `${this.userproperty}:true`;
			}


			axios({
				method: 'GET',
				url: `${apiUrl.api_url}users`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(response => {
					this.listUserData = response.data.data;
					this.listUserDatafilter = this.listUserData.map(ele => ele.email);
					this.isLoading = false;
					this.totalRows = response.data.count;
					this.resultCount = response.data.count;
					if (this.totalRows < 10) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / 10);
					}
				})
				.catch(error => {
					console.error(error);
				});
		}
		,


		//to get warehouse List
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');

		// 	// this.input = ({
		// 	// 	clientid: this.adduser.clientid,
		// 	// });
		// 	axios({
		// 		method: 'POST',
		// 		'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 		'data': {},
		// 		headers: {
		// 			'Authorization': 'Bearer ' + myStr
		// 		}
		// 	})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		// check(abc) {
		// 	this.checked_roleid = []
		// 	this.checked_roleid = abc.split(",");
		// },
		getUserRowData(data) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.isLoading = true
			axios({
				method: 'GET',
				url: `${apiUrl.api_url}users/${data.userid}`,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.userid = data.userid
					this.userPersonname = data.fullname
					this.showfeaturepermission = true
					this.addusermodal = true
					this.openMoodle = true;
					this.permissions = [
						{
							label: "b2bPieceLevelPicking",
							key: this.$t('userProperties.b2bPickScan'),
							value: false
						},
						{
							label: "b2bPieceLevelPacking",
							key: this.$t('userProperties.b2bPackScan'),
							value: false
						}]
					if (Object.keys(result.data.data.properties).length > 0) {
						for (let key in result.data.data.properties) {
							if (this.permissions.some(permission => permission.label === key)) {
								const permissionIndex = this.permissions.findIndex(permission => permission.label === key);
								this.permissions[permissionIndex].value = result.data.data.properties[key] == "true" ? true : false;
							}
						}

						if (!result.data.data.permissions.includes("PDA RackOut")) {
							const permissionIndex = this.permissions.findIndex(permission => permission.label === "b2bPieceLevelPicking");
							if (permissionIndex !== -1) {
								this.permissions.splice(permissionIndex, 1);
							}
						}
						if (!result.data.data.permissions.includes("packingb2b", "packingnewb2b", "packingb2bnew")) {
							const permissionIndex = this.permissions.findIndex(permission => permission.label === "b2bPieceLevelPacking");
							if (permissionIndex !== -1) {
								this.permissions.splice(permissionIndex, 1);
							}
						}
						this.clonedArray = JSON.parse(JSON.stringify(this.permissions));
					} else {

						if (!result.data.data.permissions.includes("PDA RackOut")) {
							const permissionIndex = this.permissions.findIndex(permission => permission.label === "b2bPieceLevelPicking");
							if (permissionIndex !== -1) {
								this.permissions.splice(permissionIndex, 1);
							}
						}
						if (!result.data.data.permissions.includes("packingb2b", "packingnewb2b", "packingb2bnew")) {
							const permissionIndex = this.permissions.findIndex(permission => permission.label === "b2bPieceLevelPacking");
							if (permissionIndex !== -1) {
								this.permissions.splice(permissionIndex, 1);
							}
						}
						if (this.permissions.length == 0) {
							this.$alertify.error(this.$t('userProperties.checkPermissionsForUser'))
							this.showfeaturepermission = false
							return false
						}
						this.clonedArray = JSON.parse(JSON.stringify(this.permissions));
					}

					this.isLoading = false;
				})
		},

		onPageChange(page) {
			this.currentPage = page;
			this.selecteduser = '';
			this.getUserData()
		},


		changeUserStatus(data) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			for (let index = 0; index < this.clonedArray.length; index++) {
				if( this.permissions[index].label == this.clonedArray[index].label && this.permissions[index].value.toString() != this.clonedArray[index].value){
					let updatedIndex = this.updatedPermission.findIndex(ele => ele && ele.name === this.clonedArray[index].label);
					if (updatedIndex !== -1) {
						this.updatedPermission[updatedIndex].value = this.permissions[index].value.toString();
					  } else {
						this.updatedPermission[index] = {
						  name: this.permissions[index].label,
						  value: this.permissions[index].value.toString()
						};
					  }
				}
				let updatedIndex = this.updatedPermission.findIndex(ele => ele && ele.name === this.clonedArray[index].label);

				if(updatedIndex !== -1){

				if(this.updatedPermission[updatedIndex]  && this.clonedArray[index].value.toString() == this.updatedPermission[updatedIndex].value){
					delete this.updatedPermission[updatedIndex]
				}
			}
			}

			this.updatedPermission = this.updatedPermission.map(item => {
				if (item !== null) {
					return { "name": item.name, "value": String(item.value) };
				} else {
					return null;
				}
			}).filter(item => item !== null);
			if (this.updatedPermission.length == 0) {
				this.$alertify.error(this.$t('userProperties.changeToggle'));
				return false;
			}
			axios({
				method: 'PUT',
				'url': apiUrl.api_url + `users/${this.userid}`,
				'data': {
					'properties': this.updatedPermission
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(this.$t(`userProperties.${response.data.errorLabel}`));
						this.clonedArray = []
						this.showfeaturepermission = false

					} else if (response.data.errorCode == -1) {
						this.$alertify.error(this.$t(`userProperties.${response.data.errorLabel}`));
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		resetForm() {
			this.userrole = '',
			this.userproperty = '',
			this.totalRows = 0;
			this.username = '';
			this.email = '';
			this.warehouse = '';
			this.selecteduser = ''
			this.listUserDatafilter = []
			this.listUserData = []
			this.resultCount = 0;
			this.permissions = [
				{
					label: "b2bPieceLevelPicking",
					key: this.$t('userProperties.b2bPickScan'),
					value: false
				},
				{
					label: "b2bPieceLevelPacking",
					key: this.$t('userProperties.b2bPackScan'),
					value: false
				}]
			this.clonedArray = []
		},

		selectUserType(data) {
			if (data == 'warehouse_user') {
				this.showwarehouse = true;
				this.showclient = false;
				this.adduser.clientid = '';
			} else if (data == 'client_user') {
				this.showwarehouse = false;
				this.adduser.warehouseid = '';
				this.showclient = true;
			} else {
				this.adduser.warehouseid = '';
				this.adduser.clientid = '';
				this.showwarehouse = false;
				this.showclient = false;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/userproperties/userproperties.component.js